var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._.get(_vm.company, "accountStatus.disabledSince", false)
        ? _c("v-icon", { attrs: { color: "accent" } }, [_vm._v("report")])
        : _vm._.get(_vm.company, "accountStatus.verified", false)
        ? _c("v-icon", { attrs: { color: "green" } }, [_vm._v("verified_user")])
        : _vm._e(),
      _vm._v(" "),
      _c("span", [_vm._v(" " + _vm._s(_vm.company.displayName))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74e44ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e44ea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyName.vue
// module id = null
// module chunks = 